import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
  useNavigate,
} from "react-router-dom";
import { apiClient } from "./Helpers/backendHelper";
import { getUserData, userLogout } from "./Helpers/utils";
import { setAuthorizationHeader } from "./Helpers/apiHelper";
import { Register } from "./Pages/Register";
import { PostLoginRegister } from "./Pages/AfterLoginRegister";
import { Home } from "./Pages/Home";
import Posts from "./Components/posts/Posts";
import Post from "./Components/posts/Post";
import { NewsHandlesContainer } from "./Components/news/newsHandles";

function SetNavigateInApiClient() {
  const navigate = useNavigate();

  useEffect(() => {
    apiClient.setNavigate(navigate);
  }, [navigate]);

  return null; // This component doesn't render anything
}

const AuthProtected: React.FC = () => {
  const user = getUserData();
  if (!user) {
    userLogout();
    return <Navigate to="/jumpin" />; // Redirect to login page
  }
  setAuthorizationHeader(user.token);
  return <Outlet />;
};

const isMobileDevice = () => window.innerWidth <= 900;

const App: React.FC = () => {
  const user = getUserData();
  return (
    <div className="App flex flex-row justify-center items-center min-h-screen">
      <Router>
        <SetNavigateInApiClient />
        <Routes>
          <Route path="/jumpin" element={<Register />} />
          <Route path="/post" element={<PostLoginRegister />} />
          <Route element={<Home />}>
            {!user && <Route path="/post/:postId" element={<Post />} />}
            {/* <Route path="/post/:postId" element={<Post />} /> */}
            <Route element={<AuthProtected />}>
              <Route path="/" element={<Posts />} />
              {user && <Route path="/post/:postId" element={<Post />} />}
              {isMobileDevice() && (
                <Route
                  path="/newsupdates"
                  element={<NewsHandlesContainer isMobile={true} />}
                />
              )}
            </Route>
            <Route path="*" element={<Navigate to="/" />} />
          </Route>
        </Routes>
      </Router>
    </div>
  );
};

export default App;
